import { render, staticRenderFns } from "./CustomToggle.vue?vue&type=template&id=19378118&scoped=true&"
import script from "./CustomToggle.vue?vue&type=script&lang=ts&"
export * from "./CustomToggle.vue?vue&type=script&lang=ts&"
import style0 from "./CustomToggle.vue?vue&type=style&index=0&id=19378118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19378118",
  null
  
)

export default component.exports